import "./Navbar.css";
import { useState } from "react";


export default function Navbar() 
{const [isNavExpanded, setIsNavExpanded] = useState(false)
    return (
        <nav className="navigation">
        <a href="/" className="brand-name">
          <b>ExpenseEdge</b>
        </a>
        <button className={`hamburger ${isNavExpanded ? "expanded" : ""}`}
        onClick={() => {
          setIsNavExpanded(!isNavExpanded)
        }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="white"
          >
            <path
              fillRule="evenodd"
              d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM9 15a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1z"
              clipRule="evenodd"
            />
          </svg>
        </button>
        <div
          className={`navigation-menu ${isNavExpanded ? "expanded" : ""}`}>
          <ul>
          <li>
              <a href="https://expense-edge.pages.dev/">Home</a>
            </li>
            <li>
              <a href="https://tax-calculator.pages.dev/">Tax Calculator</a>
            </li>
            <li>
              <a href="https://emi-calculator.pages.dev/">EMI Calculator</a>
            </li>
            <li>
            <a href="/"></a>
            </li>
          </ul>
        </div>
      </nav>
    );
  }